/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import { Box, Skeleton } from '@mui/material';

const TimeSectionSkeletons = () => (
  <>
    <Box
      data-testid="skeletons"
      // Allows grid to flow when switching to mobile, contains styling for border and margins to match height
      sx={{
        borderRight: theme => ({ xs: `1px solid ${theme.palette.graphic.light}`, md: 'none' }),
        display: 'grid',
        gridTemplateRow: '1fr 1fr',
        height: { xs: 'initial', md: 32 },
        gridRow: { xs: '1 / 3', md: '' },
        gridTemplate: { md: '1fr 1fr / 40px 1fr' },
        ml: { xs: 0, md: 'initial' },
        mr: { xs: 5, md: 'initial' },
        my: { xs: 0.5, md: 'initial' },
      }}
    >
      <Skeleton
        height="40px"
        sx={{ display: { xs: 'none', md: 'revert' }, gridRow: { xs: '', md: '1 / 3' } }}
        variant="rectangular"
        width="40px"
      />
      <Skeleton
        sx={{
          height: { xs: 30, md: 20 },
          mb: 1,
          ml: { xs: 'initial', md: 1 },
        }}
        variant="rectangular"
        width="60px"
      />
      <Skeleton
        height="14px"
        sx={{ ml: { xs: 'initial', md: 1 } }}
        variant="rectangular"
        width="105px"
      />
    </Box>
    <Box
      sx={{
        display: 'grid',
        gridTemplateRow: '1fr 1fr',
        height: { xs: 'initial', md: 32 },
        gridTemplate: { md: '1fr 1fr / 40px 1fr' },
        pb: { xs: 1, md: 'initial' },
      }}
    >
      <Skeleton
        height="40px"
        sx={{ display: { xs: 'none', md: 'revert' }, gridRow: { xs: '', md: '1 / 3' } }}
        variant="rectangular"
        width="40px"
      />
      <Skeleton
        sx={{ height: { xs: 12, md: 20 }, mb: 1, ml: { xs: 'initial', md: 1 } }}
        variant="rectangular"
        width="50px"
      />
      <Skeleton
        height="14px"
        sx={{ ml: { xs: 'initial', md: 1 } }}
        variant="rectangular"
        width="105px"
      />
    </Box>
    <Box
      sx={{
        display: 'grid',
        gridTemplateRow: '1fr 1fr',
        height: { xs: 'initial', md: 32 },
        gridTemplate: { md: '1fr 1fr / 40px 1fr' },
      }}
    >
      <Skeleton
        height="40px"
        sx={{ display: { xs: 'none', md: 'revert' }, gridRow: { xs: '', md: '1 / 3' } }}
        variant="rectangular"
        width="40px"
      />
      <Skeleton
        sx={{
          height: { xs: 12, md: 20 },
          mb: 1,
          ml: { xs: 'initial', md: 1 },
        }}
        variant="rectangular"
        width="50px"
      />
      <Skeleton
        height="14px"
        sx={{ ml: { xs: 'initial', md: 1 } }}
        variant="rectangular"
        width="105px"
      />
    </Box>
  </>
);
export default TimeSectionSkeletons;
